import { render, staticRenderFns } from "./RequestedRewards.vue?vue&type=template&id=250a5230"
import script from "./RequestedRewards.vue?vue&type=script&lang=js"
export * from "./RequestedRewards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports